export enum PBStepNames {
  USER_ROLE = 'user-role',
  KEY_EVENTS = 'key-events',
  MORE_ABOUT_YOU = 'about-you',
  ABOUT_PATIENT = 'about-patient',
  SUBSCRIBE = 'subscribe',
  YOUR_EMPLOYER = 'your-employer',
}
